import React, { useState, useEffect } from "react";
import styles from "./SingleProductMobile.module.css";
import { NavLink, useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";

import { FaStar, FaStarHalfAlt } from "react-icons/fa";
import { AiOutlineStar } from "react-icons/ai";
import searchicon from "../../assets/icons/searchicon.png";
import backbutton from "../../assets/icons/backbutton.png";
import FooterMobile from "../FooterMobile/FooterMobile";

const SingleProductMobile = () => {
  const MAIN_URL = process.env.REACT_APP_URL

  const navigate = useNavigate();

  // to get single product details
  const { productId } = useParams();
  const [product, setProduct] = React.useState(null);

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const response = await axios.get(
          `${MAIN_URL}/api/product/getProductById/${productId}`
        );
        setProduct(response.data);
        const images = response.data.carouselImgUrls.map((image, index) => (
          <div className={styles.product_single_image_item} key={index}>
            <img src={image} alt={`carousel_${index}`} />
          </div>
        ));
        setCarouselItems(images);
      } catch (error) {
        console.error("Error fetching product details:", error);
      }
    };

    fetchProduct();
  }, [productId]);
  const addToCart = async (product) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        navigate("/login");
        return;
      }
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      await axios.post(
        `${MAIN_URL}/api/cart/addToCart/${product._id}`,
        null,
        config
      );
      toast.success(`${product.productName} added to cart!`);
    } catch (error) {
      console.error("Error adding product to cart:", error);
      toast.error("Failed to add product to cart");
    }
  };
  const handleOnSlideChanged = (e) => {
    setActiveIndex(e.item);
  };

  // Carousel settings
  const [activeIndex, setActiveIndex] = useState(0);
  const [carouselItems, setCarouselItems] = useState([]);

  useEffect(() => {
    if (product && product.carouselImgUrls) {
      setCarouselItems(
        product.carouselImgUrls.map((image, index) => (
          <div className={styles.product_single_image_item} key={index}>
            <img src={image} alt={`carousel_${index}`} />
          </div>
        ))
      );
    }
  }, [product]);
  return (
    <>
      <div className={styles.singleProduct}>
        {/* Searchbar */}
        <div className={styles.product_mainContainer}>

        <div className={styles.bar_heading}>
            <div className={styles.search_bar}>
              <img className={styles.search_img} src={searchicon} alt="" />
              <input
                type="text"
                className={styles.search_input}
                placeholder="Search Musicart"
                // onChange={handleSearch}
              />
            </div>
        </div>
        {product ? (
            
          <div className={styles.product_container}>
        
            <div className={styles.product_back_btn}>
              <NavLink to="/home">
                <button className={styles.back_btn}>
                  <img src={backbutton} alt="backbutton" />
                </button>
              </NavLink>
            </div>

            <div className={styles.btn_div}>
            <button className={styles.buy_now_btn}><NavLink className={styles.link_btn} to="/viewcart">Buy Now</NavLink> </button>
            </div>
            {/* single image  */}
            <div className={styles.product_single_image}>
            <AliceCarousel
                items={carouselItems}
                activeIndex={activeIndex}
                onSlideChanged={handleOnSlideChanged}
                disableButtonsControls={true}
                disableDotsControls={false}
              />
              
            </div>

            {/* name  */}
            <div className={styles.name_div}>
            <p className={styles.product_name}> {product.productName} </p>
            </div>
            {/* REVIEW SECTION */}

            <div className={styles.ratings_section}>
              <div className={styles.star_icon}>
                {Array.from({ length: 5 }, (_, index) => {
                  const filledStars = Math.floor(product.reviews.starRating);
                  const hasHalfStar = product.reviews.starRating % 1 !== 0;
                  if (index < filledStars) {
                    return <FaStar key={index} className="icon" />;
                  } else if (hasHalfStar && index === filledStars) {
                    return <FaStarHalfAlt key={index} className="icon" />;
                  } else {
                    return <AiOutlineStar key={index} className="icon" />;
                  }
                })}
              </div>
              <p>( {product.reviews.reviewCount} Customer reviews)</p>
            </div>
            {/* PRODUCT FULL NAME  */}
            <div className={styles.product_shortdetails}>
              <p>{product.shortDescription}</p>
            </div>
            {/* short details  */}
            <div className={styles.about}>
              <span className={styles.color}>{product.color} | </span>
              <span className={styles.type}>{product.productType}</span>
              <div className={styles.price}> Price - ₹ {product.price} </div>
            </div>

            {/* details  */}
            <div className={styles.details_points}>
              <p>About this item</p>
              <ul>
                {product.fullDescription &&
                  product.fullDescription
                    .split("\n")
                    .map((description, index) => (
                      <li key={index}>{description}</li>
                    ))}
              </ul>
            </div>
            <div className={styles.product_details}>
              <div className={styles.stock}>
                <span>Available -</span> {product.stock}
              </div>
              <div className={styles.brand}>
                <span>Brand -</span> {product.brand}
              </div>
            </div>
            <div className={styles.btns}>
                <button
                  className={styles.add_to_cart_btn}
                  onClick={() => addToCart(product)}
                  style={{ cursor: "pointer" }}
                >
                  Add to cart
                </button>
                <button className={styles.buy_now_btn}> <NavLink className={styles.link_btn} to="/viewcart">Buy Now</NavLink> </button>
              </div>
          </div>
        ) : (
          <div>Loading...</div>
        )}
        </div>
       <FooterMobile/>
      </div>
      <ToastContainer />
    </>
  );
};

export default SingleProductMobile;
